var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsletterIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 14",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.063 9.269l6.504-5.27v7.568H2.433V3.998L8.937 9.27 9 9.32l.063-.051zM2 .9A1.1 1.1 0 00.9 2v10A1.1 1.1 0 002 13.1h14a1.1 1.1 0 001.1-1.1V2A1.1 1.1 0 0016 .9H2zm7 6.447L2.937 2.433h12.126L9 7.347z",
    fill: "#344B80",
    stroke: "#344B80",
    strokeWidth: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletterIcon);
export default "/_next/static/images/aae512c46e967fa8a449146beb2b888b.svg";
export { ForwardRef as ReactComponent };